import { Pipe, PipeTransform } from '@angular/core';
import {PlanRoute} from "src/app/classes/common/planRoute";

@Pipe({
  name: 'planFilter'
})
export class PlanFilterPipe implements PipeTransform {

  transform(plans: PlanRoute[], filter?: any, changed?: number): any[] {
    /** 1. Ottengo la lista mergiata di veicoli **/
    const filtered = [];


    /** 2. Applico i filtri **/

    if(!filter || filter === 'all') return plans;

    for(let plan of plans){
      if(plan.starred){
        filtered.push(plan)
      }
    }

    return filtered;
  }
}
